import { Injectable } from '@angular/core';
@Injectable()
export class VariablesGlobales {
  parametres: any = [];
}